import React from "react";
import FilterIndicator from "./FilterIndicator";

function AllFilterIndicators({
    isPriceFilterActive,
    isMaterialFilterActive,
    isInsertTypeFilterActive,
    isProductTypeFilterActive,
    isCollectionTypeFilterActive,
    priceMinMax,
    priceFilter,
    setPriceFilter,
    materialFilter,
    setMaterialFilter,
    insertTypeFilter,
    setInsertTypeFilter,
    setProductTypeFilter,
    productTypeFilter,
    collectionTypeFilter,
    setCollectionTypeFilter,
    filterProducts,
}) {
    return (
        <div className="flex flex-wrap gap-4 text-sm">
            {isPriceFilterActive ? (
                <div className="bg-gray-200 w-fit flex items-center gap-2 py-1 px-4 rounded-2xl">
                    <i
                        onClick={() => {
                            setPriceFilter(priceMinMax);
                            filterProducts(
                                priceMinMax,
                                materialFilter,
                                productTypeFilter,
                                insertTypeFilter,
                                collectionTypeFilter
                            );
                        }}
                        className={`pi pi-times text-black md:ml-4 cursor-pointer`}
                    />
                </div>
            ) : null}

            <FilterIndicator
                filter={materialFilter}
                onClick={() => {
                    setMaterialFilter([]);
                    filterProducts(
                        priceFilter,
                        [],
                        productTypeFilter,
                        insertTypeFilter,
                        collectionTypeFilter
                    );
                }}
                isActive={isMaterialFilterActive}
            />

            <FilterIndicator
                filter={insertTypeFilter}
                onClick={() => {
                    setInsertTypeFilter([]);
                    filterProducts(
                        priceFilter,
                        materialFilter,
                        productTypeFilter,
                        [],
                        collectionTypeFilter
                    );
                }}
                isActive={isInsertTypeFilterActive}
            />

            <FilterIndicator
                filter={productTypeFilter}
                onClick={() => {
                    setProductTypeFilter([]);
                    filterProducts(
                        priceFilter,
                        materialFilter,
                        [],
                        insertTypeFilter,
                        collectionTypeFilter
                    );
                }}
                isActive={isProductTypeFilterActive}
            />

            <FilterIndicator
                filter={collectionTypeFilter}
                onClick={() => {
                    setCollectionTypeFilter([]);
                    filterProducts(
                        priceFilter,
                        materialFilter,
                        productTypeFilter,
                        insertTypeFilter,
                        []
                    );
                }}
                isActive={isCollectionTypeFilterActive}
            />
        </div>
    );
}

export default AllFilterIndicators;
